import request from 'superagent';
import Cookies from 'cookies-js';
import keys from 'lodash/object/keys';

import { WATCHLIST_NAME as OVERVIEW_CHART_WATCHLIST_NAME } from 'components/Overview/OverviewChart';

import * as types from 'constants/ActionTypes';
import { WATCHLIST_URL } from 'constants/Jaws';
import { getUserId } from 'utils/user';
import doubleEncode from 'utils/doubleEncode';

export function addItem(watchlistName, itemSector, includeItems) {
  return (dispatch, getState) => {
    const { user } = getState();
    const userId = getUserId(user);

    request
      .post(
        `${WATCHLIST_URL}/${userId}/${doubleEncode(watchlistName)}` +
          `/${doubleEncode(itemSector)}`,
      )
      .end((err, res) => {
        if (err) {
          throw new Error('WatchlistActions.addItem failed: ' + err);
        }
        // TODO handle fallback
        dispatch(fetchWatchlists(includeItems));
        return res;
      });
  };
}

export function deleteItem(watchlistName, itemSector, includeItems) {
  return (dispatch, getState) => {
    const { user } = getState();
    const userId = getUserId(user);

    request
      .del(
        `${WATCHLIST_URL}/${userId}/${doubleEncode(watchlistName)}` +
          `/${doubleEncode(itemSector)}`,
      )
      .end((err, res) => {
        if (err) {
          throw new Error('WatchlistActions.deleteItem failed: ' + err);
        }
        // TODO handle fallback
        dispatch(fetchWatchlists(includeItems));
        return res;
      });
  };
}

export function invalidate() {
  return { type: types.INVALIDATE_WATCHLISTS };
}

function requestWatchlists() {
  return { type: types.REQUEST_WATCHLISTS };
}

function receiveWatchlists(data) {
  return { type: types.RECEIVE_WATCHLISTS, data };
}

function addWatchlist(name) {
  return { type: types.WATCHLIST_ADD_LIST, name };
}

function shouldFetchWatchlists(state) {
  const { watchlists } = state;
  if (watchlists.get('isFetching')) {
    return false;
  }
  return watchlists.get('didInvalidate');
}

function fetchWatchlists(includeItems) {
  return (dispatch, getState) => {
    dispatch(requestWatchlists());
    const { user } = getState();
    const userId = getUserId(user);

    const req = request.get(`${WATCHLIST_URL}/${userId}`);
    if (includeItems) {
      req.query({ includeItems });
    }
    req.end((err, res) => {
      if (err) {
        throw new Error('WatchlistActions.fetchWatchlists failed: ' + err);
      }

      const selectedCookie = Cookies.get('selectedWatchlist');

      let lists = res.body;
      if (includeItems) {
        lists = keys(lists);
      }

      const selectedExists = lists.find(list => list === selectedCookie);
      let selected;
      if (selectedExists) {
        selected = Cookies.get('selectedWatchlist');
      } else {
        selected = lists.filter(
          list => list !== OVERVIEW_CHART_WATCHLIST_NAME,
        )[0];
      }
      dispatch(receiveWatchlists(res.body));
      return dispatch(setSelected(selected));
    });
  };
}

export function fetchWatchlistsIfNeeded(includeItems) {
  return (dispatch, getState) => {
    // TODO, check if we should dispatch on includeItems?
    if (includeItems || shouldFetchWatchlists(getState())) {
      return dispatch(fetchWatchlists(includeItems));
    }
  };
}

export function setSelected(name) {
  // It should not be possible to set OVERVIEW_CHART as active watchlist
  if (name === OVERVIEW_CHART_WATCHLIST_NAME) {
    throw new Error(
      `${OVERVIEW_CHART_WATCHLIST_NAME} is not a valid watchlist`,
    );
  }

  Cookies.set('selectedWatchlist', name);
  return { type: types.SET_SELECTED_WATCHLIST, name };
}

export function createNewWatchlist(name, callback) {
  return (dispatch, getState) => {
    dispatch(addWatchlist(name));
    const { user } = getState();
    const userId = getUserId(user);
    const url = `${WATCHLIST_URL}/${userId}/${doubleEncode(name)}/EQNR.OSE`;

    request.post(url).end((err, res) => {
      if (err) {
        throw new Error('WatchlistActions.createNewWatchlist failed: ' + err);
      }
      // Delete placeholder instrument
      // TODO remove workaround
      request
        .del(url)
        .query()
        .end();
      dispatch(fetchWatchlists());
      // TODO handle fallback
      if (callback) callback(res);

      return res;
    });
  };
}

export function deleteWatchlist(name) {
  return (dispatch, getState) => {
    dispatch({ type: types.WATCHLIST_DELETE_LIST, name });
    const { user } = getState();
    const userId = getUserId(user);

    request
      .del(`${WATCHLIST_URL}/${userId}/${doubleEncode(name)}`)
      .end((err, res) => {
        if (err) {
          throw new Error('WatchlistActions.createNewWatchlist failed: ' + err);
        }
        return res;
      });
  };
}

export function updateOrder(name, itemSector, newPos) {
  return (dispatch, getState) => {
    const { user } = getState();
    const userId = getUserId(user);

    request
      .post(
        `${WATCHLIST_URL}/${userId}/${doubleEncode(name)}/` +
          `${itemSector}/${newPos}`,
      )
      .end((err, res) => {
        if (err) {
          throw new Error('watchlistActions.updateOrder failed: ' + err);
        }
        return res;
      });
  };
}
